import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Layout from 'components/common/Layout';
import Button from 'components/common/Button';
import IconCity from 'components/icons/IconCity';
import IconBuilding from 'components/icons/IconBuilding';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = theme => ({
  grid: {
    position: 'relative',
    top: '-10%',
    minHeight: 'calc(100vh - 214px)',
    zIndex: 1,
  },
  typographyTitle: {
    fontSize: pxToRem(18),
    letterSpacing: pxToEm(0.1, 18),
    color: theme.palette.primary.A400,
  },
  button: {
    minWidth: 166,
  },
  icons: {
    display: 'flex',
    position: 'absolute',
    bottom: 0,
    left: '50%',
    width: 4110,
    textAlign: 'center',
    transform: 'translateX(-50%)',
  },
  iconCity: {
    display: 'block',
    width: 1370,
    height: 212,
    color: theme.palette.primary.A100,
  },
  iconBuilding: {
    position: 'absolute',
    left: 1608,
    bottom: 0,
    width: 228,
    height: 385,
  },
});

const Error404 = ({ classes }) => (
  <Layout variant="error">
    <Helmet>
      <title>
        {appTitle} {titleSeparator} Page Not Found
      </title>
    </Helmet>
    <Grid
      className={classes.grid}
      container
      direction="column"
      alignItems="center"
      justify="center"
      spacing={24}
    >
      <Grid item>
        <Typography variant="display4" align="center">
          404
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          className={classes.typographyTitle}
          variant="title"
          align="center"
          gutterBottom
        >
          The page you were looking for doesn’t exist
        </Typography>
      </Grid>
      <Grid item>
        <Button
          className={classes.button}
          variant="raised"
          color="primary"
          href="/"
        >
          Back home
        </Button>
      </Grid>
    </Grid>
    <div className={classes.icons} role="presentation">
      <IconBuilding className={classes.iconBuilding} />
      <IconCity className={classes.iconCity} />
      <IconCity className={classes.iconCity} />
      <IconCity className={classes.iconCity} />
    </div>
  </Layout>
);

Error404.propTypes = {
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    typographyTitle: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    icons: PropTypes.string.isRequired,
    iconCity: PropTypes.string.isRequired,
    iconBuilding: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(Error404);



// WEBPACK FOOTER //
// ./src/pages/common/Error404.js